module.exports = "<sc-fact-slider model=\"model\" filter=\"filter\" filter-data=\"imagesData\" selected-fact=\"selectedImageFact\"></sc-fact-slider>"


//////////////////
// WEBPACK FOOTER
// ./src/facts/slider/facts-slider-modal.component.html
// module id = 400
// module chunks = 0